import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Tooltip,
} from "@mui/material";
import {
  Dashboard,
  DashboardIsActive,
  History,
  HistoryIsActive,
  Logout,
  LogoutIsActive,
  Notification,
  NotificationIsActive,
  Payment,
  PaymentIsActive,
  Profile,
  ProfileIsActive,
  RaiseComplaint,
  RaiseComplaintIsActive,
  Setting,
  SettingIsActive,
} from "Assets/SvgImage";
import ColorData from "Components/CstmTheme/ColorData";
import ImgPath from "Constants/Imgs";
import { RouteUrls } from "Constants/RouteUrls";
import { SIDEBAR_CONFIG } from "Constants/SidebarConfig";
import SidebarToggleButton from "./SidebarToggleButton";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import { useDispatch } from "react-redux";
import { clearUser } from "../../Redux/User/Action";
import { UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import {
  Dashboard as DashboardIcon,
  History as HistoryIcon,
  AddCircleOutline as CreateCaseIcon,
  AccountCircle as ProfileIcon,
  Payments as PaymentIcon,
  Stars as RewardIcon,
  ContactSupport as ComplaintIcon,
  ExitToApp as LogoutIcon,
  WhatsApp as WhatsAppIcon,
} from '@mui/icons-material';


export const navItems = [
  {
    label: "Home",
    inactiveIcon: (
      <HomeIcon
        sx={{
          color: ColorData.text.secondary,
          ":hover": { color: ColorData.hover.main },
        }}
      />
    ),
    activeIcon: (
      <HomeIcon
        sx={{
          color: ColorData.hover.main,
          ":hover": { color: ColorData.hover.main },
        }}
      />
    ),
    path: "/home.html",
    roles: ["USER", "PROFESSIONAL", "ADMIN", "SUPERADMIN", "CORPORATEUSER", "NRIUSER"], // Visible to everyone
  },
  {
    label: "Dashboard",
    inactiveIcon: <DashboardIcon sx={{ color: ColorData.text.secondary }} />,
    activeIcon: <DashboardIcon sx={{ color: ColorData.hover.main }} />,
    path: RouteUrls.dashboard,
    roles: ["USER", "PROFESSIONAL", "ADMIN", "SUPERADMIN", "CORPORATEUSER", "NRIUSER"], // Visible to everyone
  },
  {
    label: "Order History",
    // inactiveIcon: <History />,
    // activeIcon: <HistoryIsActive />,
    inactiveIcon: <HistoryIcon sx={{ color: ColorData.text.secondary }} />,
    activeIcon: <HistoryIcon sx={{ color: ColorData.hover.main }} />,
    path: RouteUrls.OrderHistory,
    roles: ["USER", "PROFESSIONAL", "ADMIN", "SUPERADMIN", "CORPORATEUSER", "NRIUSER"], // Visible to everyone

  },
  {
    label: "Create Case",
    inactiveIcon: <ImgPath.CaseCreationIcon sx={{ color: "custom.white" }} />,
    activeIcon: <ImgPath.CaseCreationIcon sx={{ color: "primary.main" }} />,
    path: RouteUrls.case,
    roles: ["USER", "CORPORATEUSER", "NRIUSER"], // HIDDEN for Admin, SuperAdmin, and Professional
  },
  {
    label: "Profile",
    inactiveIcon: <ProfileIcon sx={{ color: ColorData.text.secondary }} />,
    activeIcon: <ProfileIcon sx={{ color: ColorData.hover.main }} />,
    path: RouteUrls.userProfileForm,
    roles: ["USER", "PROFESSIONAL", "ADMIN", "SUPERADMIN", "CORPORATEUSER", "NRIUSER"], // Visible to everyone
  },
  // {
  //   label: "Setting",
  //   inactiveIcon: <Setting />,
  //   activeIcon: <SettingIsActive />,
  //   path: "",
  // },
  {
    label: "Payment History",
    // inactiveIcon: <History />,
    // activeIcon: <HistoryIsActive />,
    inactiveIcon: <PaymentIcon sx={{ color: ColorData.text.secondary }} />,
    activeIcon: <PaymentIcon sx={{ color: ColorData.hover.main }} />,
    path: RouteUrls.PaymentHistory,
    roles: ["USER", "PROFESSIONAL", "ADMIN", "SUPERADMIN", "CORPORATEUSER", "NRIUSER"], // Visible to everyone

  },
  {
    label: "Reward History",
    // inactiveIcon: <History />,
    // activeIcon: <HistoryIsActive />,
    inactiveIcon: <RewardIcon sx={{ color: ColorData.text.secondary }} />,
    activeIcon: <RewardIcon sx={{ color: ColorData.hover.main }} />,
    path: RouteUrls.RewardProgram,
    roles: ["USER", "CORPORATEUSER", "NRIUSER"], // HIDDEN for Admin, SuperAdmin, and Professional
  },
  {
    label: "Talk to the Case Manager",
    inactiveIcon: <ComplaintIcon sx={{ color: ColorData.text.secondary }} />,
    activeIcon: <ComplaintIcon sx={{ color: ColorData.hover.main }} />,
    path: `${RouteUrls.chat}/admin-support`,
    roles: ["PROFESSIONAL", "CORPORATEUSER", "ADMIN", "SUPERADMIN"], // Visible to Admin, SuperAdmin, and Professional
  },
  // {
  //   label: "Notification",
  //   inactiveIcon: <Notification />,
  //   activeIcon: <NotificationIsActive />,
  //   path: "",
  // },
  {
    label: "Raise Complaint",
    inactiveIcon: <ComplaintIcon sx={{ color: ColorData.text.secondary }} />,
    activeIcon: <ComplaintIcon sx={{ color: ColorData.hover.main }} />,
    path: "https://nolegalpaisa.com/help-center.html",
  },
  {
    label: "WhatsApp Dashboard",
    inactiveIcon: <WhatsAppIcon sx={{ color: ColorData.text.secondary }} />,
    activeIcon: <WhatsAppIcon sx={{ color: ColorData.hover.main }} />,
    path: RouteUrls.whatsappDashboard,
    roles: ["SUPERADMIN"],
  },
  {
    label: "Logout",
    inactiveIcon: <LogoutIcon sx={{ color: ColorData.text.secondary }} />,
    activeIcon: <LogoutIcon sx={{ color: ColorData.hover.main }} />,
    path: "/home.html",
  },
];

const Sidebar = ({
  drawerWidth,
  isCollapsed,
  onToggleCollapse,
  onClose,
  handleLogout,
}: {
  drawerWidth: number;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  onClose?: () => void;
  handleLogout?: () => void;
}) => {
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const currentUserType = myInfo?.userType;

  // Filter items based on the user's role
  const filteredNavItems = navItems.filter((item) => {
    // If roles are not defined, show to everyone by default
    if (!item.roles) return true;

    // Check if the current user's type is in the allowed roles array
    return item.roles.includes(currentUserType);
  });
  const [activeItem, setActiveItem] = useState("Dashboard");
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleItemClick = (label: string, path: string) => {
    if (label === "Logout") {
      localStorage.clear();
      dispatch(clearUser() as any);
      handleLogout?.();
      window.location.href = "/home.html";
    } else {
      setActiveItem(label);
      onClose?.();

      // If it's an external path or .html page, do full redirect
      if (path?.endsWith(".html") || path?.startsWith("http")) {
        window.location.href = path;
      } else {
        navigate(path);
      }
    }
  };

  return (
    <Box
      sx={{
        width: drawerWidth,
        height: "100vh",
        bgcolor: "primary.main",
        px: isCollapsed ? 1 : 2,
        py: 3,
        position: "relative",
        transition: `all ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
        display: "flex",
        flexDirection: "column",
        // overflow: "hidden",
      }}
    >
      {/* Toggle Button */}
      <SidebarToggleButton
        isCollapsed={isCollapsed}
        onToggle={onToggleCollapse}
      />

      {/* Logo Section */}
      <Box
        display="flex"
        justifyContent={isCollapsed ? "center" : "start"}
        sx={{
          transition: `all ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        {!isCollapsed ? (
          <img
            src={"https://nolegalpaisa.com/assets/images/new_logo.webp"}
            alt="Logo"
            style={{
              objectFit: "contain",
              width: 200,
              height: 80,
              transition: `all ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
              cursor: "pointer",
              filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
            }}
            onClick={() => {
              window.location.href = "/home.html";
            }}
          />
        ) : (
          <Box
            sx={{
              width: 40,
              height: 40,
              bgcolor: "white",
              borderRadius: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.2rem",
              fontWeight: "bold",
              color: "primary.main",
              cursor: "pointer",
            }}
            onClick={() => {
              window.location.href = "/home.html";
            }}
          >
            NLP
          </Box>
        )}
      </Box>

      {/* Navigation List */}
      <List sx={{
        overflowY: "auto",
        flex: 1,
        mt: 3,
        minHeight: 0, // Important for flex child to be scrollable
      }}>
        {filteredNavItems.map(({ label, inactiveIcon, activeIcon, path }) => {
          const isActive = label === activeItem;
          const isHovered = label === hoveredItem;

          const NavigationItem = (
            <ListItemButton
              key={label}
              onClick={() => handleItemClick(label, path)}
              onMouseEnter={() => setHoveredItem(label)}
              onMouseLeave={() => setHoveredItem(null)}
              sx={{
                borderRadius: 2,
                mb: 1.5,
                px: isCollapsed ? 1 : 2,
                py: 1.2,
                minHeight: 48,
                justifyContent: isCollapsed ? "center" : "flex-start",
                backdropFilter: "blur(8px) saturate(180%)",
                WebkitBackdropFilter: "blur(8px) saturate(180%)", // Support for Safari
                bgcolor:
                  isActive || isHovered ? "#f0e8e4" : ColorData.primary.main,
                "&:hover": {
                  bgcolor: "#f0e8e4",
                  color: ColorData.primary.main,
                },
                transition: `all ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: isCollapsed ? "auto" : 32,
                  justifyContent: "center",
                  transition: `all ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
                }}
              >
                {isActive || isHovered ? activeIcon : inactiveIcon}
              </ListItemIcon>

              {!isCollapsed && (
                <ListItemText
                  primary={
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "0.95rem",
                        fontWeight: 400,
                        color:
                          isActive || isHovered
                            ? ColorData.primary.main
                            : ColorData.text.secondary,
                        "&:hover": {
                          color: ColorData.primary.main,
                        },
                        opacity: isCollapsed ? 0 : 1,
                        transition: `opacity ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
                      }}
                    >
                      {label}
                    </Typography>
                  }
                />
              )}
            </ListItemButton>
          );

          // Wrap with Tooltip when collapsed
          return isCollapsed ? (
            <Tooltip key={label} title={label} placement="right" arrow>
              {NavigationItem}
            </Tooltip>
          ) : (
            NavigationItem
          );
        })}
      </List>
    </Box>
  );
};

export default Sidebar;
